import { IconButton } from "@mui/material";
import { routes } from "app/routes";
import { push } from "connected-react-router";
import makeStyles from "@mui/styles/makeStyles";
import { useDispatch } from "react-redux";
import CloseIcon from "@mui/icons-material/CloseRounded";

const useStyles = makeStyles((theme) => ({
    closeIcon: {
        position: "absolute",
        right: 0,
        top: 0,
        zIndex: 1,
    },
}));

export const UpdateLegacyBillingCloseIcon = () => {
    const dispatch = useDispatch();

    const classes = useStyles();

    return (
        <IconButton
            className={classes.closeIcon}
            aria-label="close"
            color="secondary"
            onClick={() => {
                dispatch(push(routes.memberMembership()));
            }}
            data-testid="closeModalButton"
        >
            <CloseIcon />
        </IconButton>
    );
};
